import { render, staticRenderFns } from "./SelectReviewPop.vue?vue&type=template&id=04fd08ca&scoped=true"
import script from "./SelectReviewPop.vue?vue&type=script&lang=ts"
export * from "./SelectReviewPop.vue?vue&type=script&lang=ts"
import style0 from "./SelectReviewPop.vue?vue&type=style&index=0&id=04fd08ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd08ca",
  null
  
)

export default component.exports